import React, { useState } from 'react';
import "./StatisticVadis.scss";
import DocumentTitle from '../../components/DocumentTitle/DocumentTitle';
import { useContext } from 'react';
import { ElementContext } from '../../services/Context/Context';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../recoil/atoms/loadingAtom';
import Api from '../../services/Api';
import { useEffect } from 'react';
import { formatStringNumber } from '../../services/Helpers/fonctions';
import { mois } from '../../utils/Data';
import { Button } from '@mui/material';
import { BsDownload } from 'react-icons/bs';
import * as XLSX from 'xlsx';
import moment from 'moment';
const StatisticVadis = () => {
  const { elementsData } = useContext(ElementContext);
  const [ isLoading,setIsLoading ]= useRecoilState(loadingState);
  const [ agenceData,setAgenceData ] = useState([]);
  const [ agenceDataMonth,setAgenceDataMonth ] = useState([]);
  const [ agenceTotal, setAgenceTotal ] = useState({
    totalHT:0,
    totalT: 0 ,
    totalTTC: 0
  });
  const [ agenceTotalMonth, setAgenceTotalMonth ] = useState({
    totalHT:0,
    totalT: 0 ,
    totalTTC: 0
  });
  const api = new Api();
  const getStats = async (agence = '',params = 'all') => {
    try{
        setIsLoading(true);setAgenceData([]);
        const response = await api.apiData("get",`/paiement/ct/statistics/${agence}`);
        const _response = await api.apiData("get",`/paiement/ct/statistics?isStatByMount=${params}`);
        if( response.status === 200 ){
           setAgenceData(response.data)  
           const newTotals = calculateTotals(response.data);
           setAgenceTotal(newTotals);
        }
        if( _response.status === 200 ){
            const newTotals = calculateTotals(_response.data);
            setAgenceTotalMonth(newTotals)
            setAgenceDataMonth(_response.data );
          }
    
    }
    catch(e){
        console.log(e)
    }
    finally{
        setIsLoading(false);
    }
  }
  const statsMonth = async (params='all') => {
    try{
       setIsLoading(true) 
      const response = await api.apiData("get",`/paiement/ct/statistics?isStatByMount=${params}`);
      if( response.status === 200 ){
        const newTotals = calculateTotals(response.data);
        setAgenceTotalMonth(newTotals)
        setAgenceDataMonth(response.data );
      }
    }
    catch(e){
        console.log(e)
    }
    finally{
        setIsLoading(false);
    }
  }
  const calculateTotals = (_data) => {
    let ht = 0;
    let t = 0;
    let ttc = 0;
  
    _data.forEach(data => {
      const montant = parseFloat(data.montantttc) || 0;
      const montantht =  !isNaN(data.montantttc) ? (parseFloat(data.montantttc) / (1 + 18/100)): 0;
      const montant_tx = !isNaN(data.montantttc) ? parseFloat(data.montantttc) - (parseFloat(data.montantttc) / (1 + 18/100)) : 0
      ht += parseFloat(montantht);
      t +=  parseFloat(montant_tx);
      ttc += montant;
    });
  
    return { totalHT: ht.toFixed(2), totalT: t.toFixed(2), totalTTC: ttc };
  };
  const exportByMonth = async () => {
   if( agenceDataMonth.length > 0 ){ 
       const workbook = XLSX.utils.book_new();
      const data = agenceDataMonth.map((dt,index) => {
        const montantht =  !isNaN(dt.montantttc) ? (dt.montantttc / (1 + 18/100)).toFixed(2): 0;
        const montant_tx = !isNaN(dt.montantttc) ? (parseFloat(dt.montantttc) - (dt.montantttc / (1 + 18/100))).toFixed(2) : 0;
      
        return {
             ordre: index + 1,
             mois:mois.filter((p) => p.id ==  dt.mois)[0]?.month || "Non fournie",
             agence: dt.nom_agence,
             montantht: montantht,
             montanttva: montant_tx,
             montantttc: parseInt(dt.montantttc)
        }
     });
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stat. Par Mois');
    XLSX.writeFile(workbook, 'exportAgenceByMonth_' + moment().format('dddd-Do-MMMM-YYYY')  + '.xlsx');
   }
  }
  const exportByAgence = async () => {
    if( agenceData.length > 0 ){
        const workbook = XLSX.utils.book_new();
        const data = agenceData.map((dt,index) => {
          const montantht =  !isNaN(dt.montantttc) ? (dt.montantttc / (1 + 18/100)).toFixed(2): 0;
          const montant_tx = !isNaN(dt.montantttc) ? (parseFloat(dt.montantttc) - (dt.montantttc / (1 + 18/100))).toFixed(2) : 0
            return {
                 ordre: index + 1,
                 agence: dt.nom_agence,
                 montantht: montantht,
                 montanttva: montant_tx,
                 montantttc: parseInt(dt.montantttc)
            }
      });
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Stat Par Agence');
      XLSX.writeFile(workbook, 'exportAgence_' + moment().format('dddd-Do-MMMM-YYYY')  + '.xlsx');
    }   
  }
  useEffect(() => {
     getStats()
  },[]);
  return (
    <div className='page statistics'>
        <DocumentTitle title="Statistiques" />
       <div className="header">
         <h3>Statistique des Paiements</h3>
         <hr />
       </div> 
       <div className='body'>
         <div className='statistic-1'>
           <div className='input-group'>
             <label>
                Filtrer par center
                <select
                onChange={(e) => getStats(e.target.value) }
                >
                   <option value="">---</option>
                   {elementsData?.agences.length > 0 && elementsData.agences.map((agence,index) => (
                     <option value={agence.agence_id} key={index + 1} >{ agence.nom_agence}</option>
                   ))}
                </select>
             </label>
             <label></label>
             <label></label>
             <div>
             <Button
                variant="text"
                startIcon={<BsDownload />}
                sx={{ marginLeft: 1 }}
                onClick={exportByAgence}
               >
               Exporter
             </Button>
           </div> 
           </div>
           
           <div className='array'>
             <table className="dataTable">
                <thead>
                   <tr>
                     <th>N°</th>
                     <th>Agence</th>
                     <th>Montant Brut (HT)</th>
                     <th>Montant TVA(18%)</th>
                     <th>Montant TTC</th>
                   </tr>
                </thead>
                <tbody>
                  { agenceData.length > 0 && agenceData.map((data,index) => {
                  //  const montantht =  !isNaN(dt.price) ? (dt.price / (1 + 18/100)).toFixed(2): 0;
                  //  const montant_tx = !isNaN(dt.price) ? (parseFloat(dt.price) - (dt.price / (1 + 18/100))).toFixed(2) : 0
                  return (
                    <tr key={data.agence_id}>
                        <td>{ index + 1 }</td>
                        <td>{ data.nom_agence }</td>
                        <td> { !isNaN(data.montantttc) ? formatStringNumber((data.montantttc / (1 + 18/100)).toFixed(2)): 0 }</td>
                        <td> { !isNaN(data.montantttc) ? formatStringNumber((parseFloat(data.montantttc) - (data.montantttc / (1 + 18/100))).toFixed(2)) : 0 }</td>
                        <td>{ formatStringNumber(data.montantttc) }</td>
                    </tr>
                    )
                     }
                   )
                  }
                  { agenceData.length === 0 &&
                   <tr className='empty-data'>
                     <td colSpan={5}>Pas de données trouvées</td>
                   </tr>
                  }
                  {agenceData.length > 0 && 
                    <tr>
                      <td colSpan={2}>Totaux</td>
                      <td>{ formatStringNumber(agenceTotal.totalHT) + " FG"}</td>
                      <td>{ formatStringNumber(agenceTotal.totalT) + " FG" }</td>
                      <td>{ formatStringNumber(agenceTotal.totalTTC) + " FG" }</td>
                    </tr>
                  }
                </tbody>
             </table>
           </div>
         </div>
         <div className='statistic-2'>
           <div className='input-group'>
             <label>
                Filtrer par mois
                <select
                 onChange={(e) => statsMonth(e.target.value === "" ? "all":e.target.value) }
                >
                   <option value="">---</option> 
                   { mois.length > 0 && mois.map((m) => (<option value={m.id} key={m.id}>{ m.month }</option> ))}
                </select>
              </label>  
              <label></label>  
              <label></label>  
              <div>
                <Button
                    variant="text"
                    startIcon={<BsDownload />}
                    sx={{ marginLeft: 1 }}
                    onClick={exportByMonth}
                >
                Exporter
                </Button>
            </div>  
           </div>
           <div className='array'>
             <table className="dataTable">
               <thead>
                 <tr>
                    <th>N°</th>
                    <th>Mois</th>
                    <th>Agence</th>
                    <th>Montant Brut (HT)</th>
                     <th>Montant TVA(18%)</th>
                     <th>Montant TTC</th>
                 </tr>
               </thead> 
               <tbody>
                 {agenceDataMonth.length > 0 && agenceDataMonth.map((data,index) => (
                    <tr key={index}>
                        <td>{ index  + 1 }</td>
                        <td>{ mois.filter((p) => p.id ==  data.mois)[0]?.month || "Non fournie" }</td>
                        <td>{ data.nom_agence }</td>
                        <td>{  !isNaN(data.montantttc) ? formatStringNumber((data.montantttc / (1 + 18/100)).toFixed(2)): 0 }</td>
                        <td> { !isNaN(data.montantttc) ? formatStringNumber((parseFloat(data.montantttc) - (data.montantttc / (1 + 18/100))).toFixed(2)) : 0}</td>
                        <td>{ formatStringNumber(data.montantttc) }</td>
                    </tr>
                 )) }
                   { agenceDataMonth.length === 0 &&
                   <tr className='empty-data'>
                     <td colSpan={6}>Pas de données trouvées</td>
                   </tr>
                  }
                  {agenceDataMonth.length > 0 && 
                    <tr>
                      <td colSpan={3}>Totaux</td>
                      <td>{ formatStringNumber(agenceTotalMonth.totalHT) + " FG"}</td>
                      <td>{ formatStringNumber(agenceTotalMonth.totalT) + " FG" }</td>
                      <td>{ formatStringNumber(agenceTotalMonth.totalTTC) + " FG" }</td>
                    </tr>
                  }
               </tbody>
             </table>
           </div>       
         </div>
       </div>
    </div>
  )
}

export default StatisticVadis